<template>
    <!-- <Transition :name="isDesktop.screenSize.value == 'xs' ? 'modalslide' : 'fade'"> -->
    <app-modal :size="size" :grid="true" v-if="hasRole(modalShowVal)">
        <app-modal-content>
            <AppModalHeader :headingText="'Manage notifications'" :classes="''" @onHeaderToggle="toggleModal">
            </AppModalHeader>
            <AppModalBody classes="bg-white dark:!bg-black-500">
                <template v-for="(toggle, index) in noticeArray" :key="index">
                    <div class="mb-6 last:mb-0">
                        <FormKit
                            type="toggle"
                            :label="toggle.label"
                            :value="toggle.value"
                        />
                    </div>
                </template>
            </AppModalBody>
            <app-modal-footer variant="secondary" :showCancelButton="false" @onHideModal="toggleModal" saveBtnText="Done" @onSubmit="toggleModal">
            </app-modal-footer>
        </app-modal-content>
    </app-modal>
    <!-- </Transition> -->
</template>

<script setup>
import { ref, defineExpose } from "vue";
import AppModal from "@/components/appComponents/modal/AppModal.vue";
import AppModalBody from "@/components/appComponents/modal/AppModalBody.vue";
import AppModalContent from "@/components/appComponents/modal/AppModalContent.vue";
import AppModalFooter from "@/components/appComponents/modal/AppModalFooter.vue";
import AppModalHeader from "@/components/appComponents/modal/AppModalHeader.vue"; // Fixed import here
import useToggleModal from "@/composables/useToggleModal";
import { useScreenSize } from "@/composables/globals";

const props = defineProps({
    modalShowVal: {
        type: String,
        default: "",
        required: true,
    },
    size: {
        type: String,
        default: "large",
    },
});

const isDesktop = useScreenSize();
const { openModal, hasRole, toggleModal } = useToggleModal();
const emit = defineEmits(["onHideModal"]);

// Show modal logic
const showModal = (modalShowVal) => {
    console.log(modalShowVal, "checking modal modalShowVal");
    openModal(modalShowVal); // directly call openModal
};
const noticeArray = ref([
    {
        label: "New users",
        value: false,
    },
    {
        label: "Diary invites",
        value: true,
    },
    {
        label: "Offers",
        value: false,
    },
    {
        label: "Documents signed",
        value: false,
    },
    {
        label: "Permissions request",
        value: false,
    },
]);
defineExpose({
    showModal,
});
</script>

<style scoped></style>
